import React, { useState } from 'react';
import { Modal } from 'native-base';
import RichTextBox from './RichTextBox';
import { NEW_TOPIC_MODAL_MIN_HEIGHT, MODAL_WIDTH } from '../../../Constants';
import { useCategoriesState } from '../../../../context/categories';
const NewTopicBox = ({
  showNewTopicModal,
  setShowNewTopicModal,
  handlePost,
  onCloseHandler
}) => {
  var _categoriesState$sele;
  const categoriesState = useCategoriesState();
  const [selectedPostCategoryId, setSelectedPostCategoryId] = useState((categoriesState === null || categoriesState === void 0 || (_categoriesState$sele = categoriesState.selectedCategory) === null || _categoriesState$sele === void 0 ? void 0 : _categoriesState$sele.id) ?? undefined);
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: showNewTopicModal,
    onClose: () => setShowNewTopicModal(false),
    size: MODAL_WIDTH,
    w: "container",
    minH: NEW_TOPIC_MODAL_MIN_HEIGHT
  }, /*#__PURE__*/React.createElement(Modal.Content, {
    minH: NEW_TOPIC_MODAL_MIN_HEIGHT
  }, /*#__PURE__*/React.createElement(Modal.CloseButton, null), /*#__PURE__*/React.createElement(Modal.Header, null, "Create a new topic"), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(RichTextBox, {
    selectedPostCategoryId: selectedPostCategoryId,
    setSelectedPostCategoryId: setSelectedPostCategoryId,
    handlePost: handlePost,
    setShowModal: setShowNewTopicModal,
    onCloseHandler: onCloseHandler,
    id: "newTopic",
    key: "newTopic"
  }))));
};
export default NewTopicBox;
//# sourceMappingURL=NewTopicBox.js.map